/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import {
    parseAbsolute,
    toCalendarDate,
    getLocalTimeZone,
    toCalendarDateTime,
    toZoned,
} from '@internationalized/date';
import { DatePicker, localToday } from 'sarsaparilla';

export function TripDates({ trip }) {
    const handleDateChange = (value, validation) => {
        // bail if the date is not valid
        if (validation.isInvalid) return;

        // const newDate = value ? value.toDate(getLocalTimeZone()).toISOString() : '';
        const newDate = value
            ? toZoned(toCalendarDateTime(value), getLocalTimeZone()).toAbsoluteString()
            : '';

        /**
         * yep, that's right ... there is no proper state management or redux dispatch,
         * or using React in any way like it was designed. We just override the props object
         * from the parent and as long as nobody breaths on it, it will continue to "work".
         *
         * *sigh*
         *
         * Yes, this whole thing needs to be refactored and made to work correctly
         */

        // eslint-disable-next-line no-param-reassign
        trip.start_date = newDate;
    };

    const startCalendarDate = trip.start_date
        ? toCalendarDate(parseAbsolute(trip.start_date))
        : null;

    return (
        <div className="rec-form-item-wrap">
            <DatePicker
                label="Start Date"
                defaultValue={startCalendarDate}
                onChange={handleDateChange}
                minValue={localToday}
            />
        </div>
    );
}

TripDates.propTypes = {
    trip: PropTypes.object,
};

export default TripDates;
